import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = ["name", "id"]

import { ref, Ref, onMounted, watch } from 'vue';
    import {ClientJS} from "clientjs";
    import axios, { AxiosResponse } from 'axios';
    import {OwnCaptchaSubmitResponse} from 'OwnCaptchaSubmitResponse';

    type EmitTypes = {
        captchaready: (nonce: string, signature: string, honeypotName: string, honeypotValue: string) => void;
        handleevents: (applyButtonUsed: boolean, isInteractionDetected: boolean) => void;
    };

    
export default /*#__PURE__*/_defineComponent({
  __name: 'OwnCaptcha',
  props: {
    dclang_apply: {}
  },
  emits: ["captchaready", "handleevents"],
  setup(__props: any, { emit: __emit }) {

    const nonce: Ref<string> = ref("");
    const signature: Ref<string> = ref("");
    const userFingerPrint: Ref<number> = ref(0);
    const honeyPotValue: Ref<string> = ref("");
    const isInteractionDetected: Ref<boolean> = ref(false);
    const applyButtonUsed: Ref<boolean> = ref(false);
    const honeyPotName:Ref<string> = ref("displayname" + Math.random().toString(36).substr(2, 8));

    const props = __props;

   const emit = __emit;

    onMounted(async ()=> {
    const client = new ClientJS();
    userFingerPrint.value = client.getFingerprint();

    window.addEventListener("mousemove", detectInteraction);

    await loadCaptcha();

        emit("captchaready", nonce.value, signature.value, honeyPotName.value, honeyPotValue.value);
    });

    function detectInteraction() {
        isInteractionDetected.value = true;
        window.removeEventListener("mousemove", detectInteraction); 
        emit("handleevents", applyButtonUsed.value, isInteractionDetected.value);
    }

    function isApplyButtonClicked() {
      applyButtonUsed.value = true;

      emit("handleevents", applyButtonUsed.value, isInteractionDetected.value);
    }

    async function loadCaptcha(){
        const url = "/api/v1.0/check10/AddInformations";
        await axios.post<OwnCaptchaSubmitResponse>(url, {'UserFingerPrint': userFingerPrint.value }).then(function (response: AxiosResponse<OwnCaptchaSubmitResponse>) {

        nonce.value = response.data.Nonce;
        signature.value = response.data.Signature;
    });

    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      name: honeyPotName.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((honeyPotValue).value = $event)),
      type: "text",
      id: honeyPotName.value,
      class: "form-control displaycolor64"
    }, null, 8 /* PROPS */, _hoisted_2), [
      [_vModelText, honeyPotValue.value]
    ]),
    _createElementVNode("button", {
      id: "apply-button",
      name: "apply-button",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (isApplyButtonClicked())),
      class: "btn btn-primary displaycolor64"
    }, _toDisplayString(_ctx.dclang_apply), 1 /* TEXT */)
  ]))
}
}

})